import { SET_LOGIN_SLIDER_ITEMS_ACTION } from './actionTypes';
import { List } from 'immutable';
import { LoginSliderItem } from '../entities/ILoginSliderItem';
import { createSyncAction } from '@bimser/core';

const setLoginSliderItemsAction = (data: List<LoginSliderItem>) =>
	createSyncAction(SET_LOGIN_SLIDER_ITEMS_ACTION, data);

export default setLoginSliderItemsAction;
